import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { resetPassword } from "../_redux/authCrud";
import { validateToken } from "../_redux/authCrud";

const initialValues = {
  password: "",
};

function ResetPassword(props) {
  const { intl } = props;
  const [isValidToken, setIsValidToken] = useState("");
  const [isRequested, setIsRequested] = useState(false);

  const query = new URLSearchParams(props.location.search);
  const token = query.get('token');

  useEffect(() => {

    if (token) {
      validateToken(token)
        .then(() => setIsValidToken(true))
        .catch(() => {
          setIsValidToken(false);
        });
    }
  }, [token]);

  const ResetPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .min(8, "Minimum 8 symbols using a combination of letters, special chars and or numbers.")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ResetPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      resetPassword(values.password, token)
        .then(() => setIsRequested(true))
        .catch(() => {
          setIsRequested(false);
          setSubmitting(false);
          setStatus(
            intl.formatMessage(
              { id: "AUTH.VALIDATION.NOT_FOUND" },
              { name: values.password }
            )
          );
        });
    },
  });

  if (isValidToken === "") {
    return null;
  }

  if (isValidToken === false) {
    return <div className="text-center mb-10 mb-lg-20">
      <h3 className="font-size-h1">Invalid or missing token!</h3>
      <div className="text-muted font-weight-bold">
        Either the token has expired or is missing in your request!
      </div>
    </div>
  }

  return (
    <>
      {isRequested &&
        <>
          <div className="text-center mb-10 mb-lg-20">
            <h3 className="font-size-h1">Password successfully changed</h3>
            <div className="text-muted font-weight-bold">
              <div className="text-muted font-weight-bold">
                <Link to="/auth">Click here to login using your new password</Link>
              </div>
            </div>
          </div>
        </>
      }
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-center mb-10 mb-lg-20">
            <h3 className="font-size-h1">New Password</h3>
            <div className="text-muted font-weight-bold">
              Enter new password
            </div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}
            <div className="form-group fv-plugins-icon-container">
              <input
                type="password"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "password"
                )}`}
                name="password"
                {...formik.getFieldProps("password")}
              />
              {formik.touched.password && formik.errors.password ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.password}</div>
                </div>
              ) : null}
            </div>
            <div className="form-group d-flex flex-wrap flex-center">
              <button
                id="kt_login_forgot_submit"
                type="submit"
                className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                disabled={formik.isSubmitting}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(ResetPassword));
